import React, { useCallback, useEffect } from 'react'

import { FlatTabbar } from 'common-components'
import {
  AI_GENERATE_TAB_KEY,
  AI_HISTORY_TAB_KEY,
  AI_IMAGE_TABS_DATA
} from './consts'
import { TAB_CONTENT } from './tabContent'
import { TAITabKey } from './types'
import { ActiveTabContext } from './contextApi'
import * as Styled from './styled'
import { aiImageThunks } from 'store/features/aiImage/thunks'
import { aiImageSelectors } from 'store/features/aiImage/selectors'
import { useSelector } from 'react-redux'
import { dispatch } from 'store'
import { editorSelectors } from 'store/features/editor/selectors'
import AiImageGenerateTab from './GenerateTab'
import { PROJECT_MEDIA_TYPES } from 'consts'

const AiImageContent: React.FC = () => {
  const activeTabKey = useSelector(aiImageSelectors.activeTab)
  const targetMediaItemId = useSelector(aiImageSelectors.targetMediaItemId)
  const aspectRatio = useSelector(aiImageSelectors.aspectRatio)
  const showVersionHistoryTab = useSelector(
    aiImageSelectors.showVersionHistoryTab
  )
  const isRegenerateForm = !!targetMediaItemId
  const activeTimelineItem = useSelector(editorSelectors.activeTimelineItem)
  const hasSelectedItem =
    activeTimelineItem.type === PROJECT_MEDIA_TYPES.aiImage ||
    activeTimelineItem.type === PROJECT_MEDIA_TYPES.image
  const showTabs = hasSelectedItem || showVersionHistoryTab

  const setActiveTabKey = useCallback((key: string) => {
    dispatch(aiImageThunks.setActiveTab(key))
  }, [])

  const onTabNameClick = useCallback(
    (key: string) => {
      if (activeTabKey !== key) {
        setActiveTabKey(key)
      }
    },
    [activeTabKey, setActiveTabKey]
  )

  useEffect(
    () => () => {
      if (isRegenerateForm) {
        dispatch(aiImageThunks.resetGenerateForm())
      }
      dispatch(aiImageThunks.setShowVersionHistoryTab(false))
      // Don't reset tab on unmount - let it persist when switching between overlays
      // The tab will be reset when actually leaving the AI_IMAGE sidebar tab
    },
    // no deps to ensure it runs only on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  useEffect(() => {
    if (hasSelectedItem && activeTabKey !== AI_HISTORY_TAB_KEY) {
      setActiveTabKey(AI_GENERATE_TAB_KEY)
    }
  }, [hasSelectedItem, setActiveTabKey, activeTabKey])

  useEffect(() => {
    if (!aspectRatio) {
      dispatch(aiImageThunks.setModelCode())
    }
  }, [aspectRatio])

  return (
    <ActiveTabContext.Provider value={{ activeTabKey, setActiveTabKey }}>
      <Styled.AiImageContentContainer $hasSelectedItem={showTabs}>
        {showTabs && (
          <Styled.TabbarWrapper>
            <FlatTabbar
              dataWithTexts={AI_IMAGE_TABS_DATA}
              defaultActiveTabName={activeTabKey}
              onCurrentItemClick={onTabNameClick}
            />
          </Styled.TabbarWrapper>
        )}
        {showTabs ? (
          TAB_CONTENT[activeTabKey as TAITabKey]
        ) : (
          <AiImageGenerateTab />
        )}
      </Styled.AiImageContentContainer>
    </ActiveTabContext.Provider>
  )
}

export default AiImageContent
